module.exports = __webpack_public_path__ + "img/sale-04.8136a160.svg";